import {Group} from "three";
import * as THREE from "three";
import {DeskTween} from "@/Classes/Animation/DeskTween.js";
import {GLTFLoader, OBJLoader} from "three/addons";

class Accessories extends Group {

    accessoriesTween;
    tabletopHeight;

    constructor(tabletopSize, tableHeight, accessories) {
        super();
        const app = this;
        this.accessoriesTween = [];
        this.tabletopHeight = tabletopSize.height;

        const accessoryMethods = {
            hole_left() {
                let material = new THREE.MeshStandardMaterial({
                        color: '#383838',
                        roughness: 0.6,
                        metalness: 0.0,
                    });
                let cableHole = new THREE.Mesh(new THREE.CylinderGeometry(3, 3, tabletopSize.height + 0.2), material);
                cableHole.position.x = -tabletopSize.width / 2 + 10;
                cableHole.position.z = -tabletopSize.depth / 2 + 10;
                cableHole.position.y = tableHeight.value - tabletopSize.height / 2;
                cableHole.receiveShadow = true;
                app.add(cableHole)
                app.accessoriesTween.push(new DeskTween(cableHole.position));
            },
            hole_right() {
                let material = new THREE.MeshStandardMaterial({
                        color: '#383838',
                        roughness: 0.6,
                        metalness: 0.0,
                    });
                let cableHole = new THREE.Mesh(new THREE.CylinderGeometry(3, 3, tabletopSize.height + 0.2), material);
                cableHole.position.x = tabletopSize.width / 2 - 10;
                cableHole.position.z = -tabletopSize.depth / 2 + 10;
                cableHole.position.y = tableHeight.value - tabletopSize.height / 2;
                cableHole.receiveShadow = true;
                app.add(cableHole)
                app.accessoriesTween.push(new DeskTween(cableHole.position));
            },

            tch2p() {
                const loader = new GLTFLoader();
                loader.load('/3ds/accessories/TCH2P.glb', function (obj) {
                    let material = new THREE.MeshStandardMaterial({
                        color: '#383838',
                        roughness: 0.6,
                        metalness: 0.0,
                    });
                    obj = obj.scene;
                    const scale = 0.1;

                    obj.traverse(function (node) {
                        if (node.isMesh) {
                            node.castShadow = true;
                            node.material = material;
                            node.receiveShadow = true;
                        }
                    });
                    obj.scale.set(scale * obj.scale.x, scale * obj.scale.y, scale * obj.scale.z)
                    obj.position.x = tabletopSize.width / 2 - 20;
                    obj.position.y = tableHeight.value - tabletopSize.height / 2 -1;
                    obj.position.z = tabletopSize.depth / 2;
                    obj.receiveShadow = true;
                    obj.castShadow = true;

                    app.add(obj);
                    app.accessoriesTween.push(new DeskTween(obj.position));
                }, undefined, function (error) {
                    console.error(error);
                })

            },

            tdh6() {
                const loader = new GLTFLoader();
                loader.load('/3ds/accessories/TDH6.glb', function (obj) {
                    let material = new THREE.MeshStandardMaterial({
                        color: '#383838',
                        roughness: 0.6,
                        metalness: 0.0,
                    });
                    obj = obj.scene;
                    const scale = 0.1;

                    obj.traverse(function (node) {
                        if (node.isMesh) {
                            node.castShadow = true;
                            node.receiveShadow = true;
                            node.material = material;
                        }
                    });
                    obj.scale.set(scale * obj.scale.x, scale * obj.scale.y, scale * obj.scale.z)
                    obj.position.x = -tabletopSize.width / 2 + 20;
                    obj.position.y = tableHeight.value - tabletopSize.height / 2 -2.5;
                    obj.position.z = tabletopSize.depth / 2;
                    obj.receiveShadow = true;
                    obj.castShadow = true;

                    app.add(obj);
                    app.accessoriesTween.push(new DeskTween(obj.position));
                    }, undefined, function (error) {
                    console.error(error);
                })

            },
        };


        accessories.forEach((accessory) => {
            if (accessory.visual_action) {
                accessoryMethods[accessory.visual_action]()
            }
        });
    }

    updateHeight(height) {
        this.accessoriesTween.forEach((child) => {
            child?.updateHeight(height - this.tabletopHeight / 2 -2.5);
        })
    }
}

export {Accessories};
